(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
/* Preserve Shopify's collection membership, filters and page size; group availability across pages. */
if (!customElements.get('gelme-portfolio-order')) {
  customElements.define('gelme-portfolio-order', class extends HTMLElement {
    connectedCallback() {
      if (Number(this.dataset.pages) <= 1) return;
      this.controller = new AbortController();
      queueMicrotask(() => this.orderPages());
    }
    disconnectedCallback() {
      if (this.controller) this.controller.abort();
    }
    async orderPages() {
      const grid = this.parentElement.querySelector('#product-grid');
      if (!grid || !this.isConnected) return;
      const pageCount = Number(this.dataset.pages);
      const currentPage = Number(this.dataset.page);
      const pageSize = Number(this.dataset.pageSize);
      const expectedCount = Number(this.dataset.count);
      const selector = 'li[data-portfolio-product]';
      const pages = new Array(pageCount);
      pages[currentPage - 1] = Array.from(grid.children).filter(node => node.matches(selector));
      const pending = Array.from({ length: pageCount }, (_, index) => index + 1).filter(page => page !== currentPage);
      const base = new URL(window.location.href);
      base.pathname = this.dataset.url;
      base.hash = '';
      base.searchParams.set('section_id', this.dataset.section);
      const timeout = setTimeout(() => this.controller.abort(), 15000);
      try {
        const worker = async () => {
          while (pending.length) {
            const page = pending.shift();
            const url = new URL(base);
            url.searchParams.set('page', String(page));
            const response = await fetch(url, { signal: this.controller.signal, credentials: 'same-origin' });
            if (!response.ok) throw new Error('Collection page unavailable');
            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            const marker = html.querySelector('gelme-portfolio-order');
            if (!marker || Number(marker.dataset.page) !== page || Number(marker.dataset.count) !== expectedCount) {
              throw new Error('Collection changed while loading');
            }
            pages[page - 1] = Array.from(html.querySelectorAll('#product-grid > ' + selector));
          }
        };
        await Promise.all(Array.from({ length: Math.min(3, pending.length) }, worker));
        const cards = pages.flat();
        const ids = new Set(cards.map(card => card.dataset.portfolioProduct));
        if (cards.length !== expectedCount || ids.size !== cards.length) throw new Error('Incomplete collection');
        const available = cards.filter(card => card.dataset.portfolioAvailable === 'true');
        const sold = cards.filter(card => card.dataset.portfolioAvailable !== 'true');
        const visible = available.concat(sold).slice((currentPage - 1) * pageSize, currentPage * pageSize);
        if (!this.isConnected || this.controller.signal.aborted) return;
        const fragment = document.createDocumentFragment();
        visible.forEach((card, index) => {
          const item = document.importNode(card, true);
          item.classList.remove('scroll-trigger--offscreen');
          if (item.style.getPropertyValue('--animation-order')) item.style.setProperty('--animation-order', index + 1);
          fragment.appendChild(item);
        });
        grid.replaceChildren(fragment);
        this.dataset.sorted = 'true';
      } catch (error) {
        if (this.isConnected) console.warn('Portfolio ordering kept the original collection:', error.message);
      } finally {
        clearTimeout(timeout);
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
